import { render, staticRenderFns } from "./DetailPageWrap.vue?vue&type=template&id=1c59d3d6&"
import script from "./DetailPageWrap.vue?vue&type=script&lang=js&"
export * from "./DetailPageWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports